import { Screen, Text, TextInput } from "components"
import React, { useEffect, useRef, useState } from "react"
import { FlatList, View } from "react-native"
import { style } from "./styles"
import { translate } from "i18n"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { colors } from "colors"
import Feather from "@expo/vector-icons/Feather"
import moment from "moment"
import { ActivityIndicator } from "react-native-paper"
import { useColor } from "app/theme/getThemes"

export const EmployeeIssueVoucherHistoryScreen = () => {
    const { companyTheme } = useColor()
  const { userStore } = useStores()
  const { sessionExpired } = useSessionExpired()
  const [voucher, setVoucher] = useState()
  const [loading, setLoading] = useState(false)
  const searchTextRef = useRef()

  useEffect(() => {
    getMemberVoucher("")
  }, [])

  const getMemberVoucher = async (text: any) => {
    setLoading(true)
    const searchTextQueryParam = text ? `/${text}` : ""

    await fetch(
      `${process.env.API_URL}/api/voucher/issued/${userStore?.id}${searchTextQueryParam}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      },
    )
      .then(async (res) => {
        setLoading(false)
        if (res?.ok) {
          const responseData = await res?.json()
          setVoucher(responseData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        setLoading(false)
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  return (
    <Screen>
      <View style={style.container}>
        <Text style={style.titleText}>{translate("employeeIssueVoucherHistoryScreen.title")}</Text>

        <TextInput
          textFieldContainer={{ borderRadius: 10, marginBottom: 20 }}
          textFieldStyle={{ height: 40 }}
          textRef={searchTextRef}
          rightIcon={() => (
            <Feather
              onPress={() => {
                searchTextRef?.current && getMemberVoucher(searchTextRef?.current?.value)
              }}
              name="search"
              size={30}
              color={companyTheme.first}
            />
          )}
          onSubmitEditing={(e) => {
            getMemberVoucher(e?.nativeEvent?.text)
          }}
          placeholder={translate("employeeIssueVoucherHistoryScreen.searchPlaceholder")}
        />
        <FlatList
          data={voucher}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={style.flex}
          ListEmptyComponent={() => {
            return (
              <View style={style.emptyContainer}>
                {loading ? (
                  <ActivityIndicator size="large" color={companyTheme.first} />
                ) : (
                  <>
                    <Text style={style.emptyTitle}>
                      {translate("employeeIssueVoucherHistoryScreen.noVoucherIssued")}
                    </Text>
                  </>
                )}
              </View>
            )
          }}
          renderItem={({ item }) => {
            return (
              <View style={style.contentView}>
                <Text style={style.contentText}>
                  {translate("employeeIssueVoucherHistoryScreen.customerName")}: {item?.fullname}
                </Text>
                <Text style={style.contentText}>
                  {translate("employeeIssueVoucherHistoryScreen.outletName")}: {item?.outlet_name}
                </Text>
                <Text style={style.contentText}>
                  {translate("employeeIssueVoucherHistoryScreen.issuedOn")}:{" "}
                  {moment(item?.redeem_at)?.format("DD-MM-YYYY hh:mm a")}
                </Text>
                <Text style={style.text}>
                  {translate("employeeIssueVoucherHistoryScreen.voucherName")}: {item?.title}
                </Text>
              </View>
            )
          }}
        />
      </View>
    </Screen>
  )
}
